module.exports = __webpack_public_path__ + "static/AR-703dea6dab3bb50cbee262f4f6d560ad.svg";